import { lazy, Suspense } from "react";
import { moduleName } from "../Constant/common";
import ChangePassword from "../Pages/Authentication/ChangePassword";
import CenterPage from "../Pages/Center";
import Company from "../Pages/Company";
import Contact from "../Pages/Contact";
import GlobalConfig from "../Pages/GlobalConfig";
import HrLayout from "../Pages/Hr Layout/Layout";
import AttendanceApproval from "../Pages/Hr/AttendanceApproval";
import EditSalary from "../Pages/Hr/HR_Salary/editSalary";
import ReviseSalary from "../Pages/Hr/HR_Salary/reviseSalary";
import SalaryHistory from "../Pages/Hr/HR_Salary/salaryHistory";
import SalaryOverview from "../Pages/Hr/HR_Salary/salaryOverview";
import SalaryStructure from "../Pages/Hr/HR_Salary/salaryStructure";
import HrDashboard from "../Pages/Hr/HrDashboard";
import LeaveApproval from "../Pages/Hr/LeaveApproval";
import EditLateEntry from "../Pages/Hr/Setting/EditLateEntry";
import ExtraWorkingDay from "../Pages/Hr/Setting/ExtraWorkingDay/ExtraWorkingDay";
import CreateHolidayTemplate from "../Pages/Hr/Setting/HR_Holiday/CreateHolidayTemplate";
import HolidayTemplate from "../Pages/Hr/Setting/HR_Holiday/HolidayTemplate";
import ManageStaff from "../Pages/Hr/Setting/HR_Holiday/ManageStaff";
import AddEditLeaveTemplate from "../Pages/Hr/Setting/HR_Leave_Template/add_edit_leave_template";
import LeaveTemplate from "../Pages/Hr/Setting/HR_Leave_Template/index";
import ManageLeaveStaff from "../Pages/Hr/Setting/HR_Leave_Template/manage_staff";
import LateEntry from "../Pages/Hr/Setting/LateEntry";
import Report from "../Pages/Hr/Setting/report";
import SalaryDetails from "../Pages/Hr/Setting/SalaryDetails/SalaryDetails";
import Setting from "../Pages/Hr/Setting/Setting";
import LetterTemplates from "../Pages/Hr/Setting/LetterTemplates";
import AddEditShift from "../Pages/Hr/Setting/Shift_Setting/AddEditShift";
import ManageShiftStaff from "../Pages/Hr/Setting/Shift_Setting/ManageShiftStaff";
import ShiftSetting from "../Pages/Hr/Setting/Shift_Setting/ShiftSetting";
import StaffHR from "../Pages/HR_Staff";
import AttendanceDetails from "../Pages/HR_Staff/AttendanceDetails";
import LeaveBalance from "../Pages/HR_Staff/LeaveBalance";
import LeaveSummary from "../Pages/HR_Staff/LeaveSummary";
import StaffProfile from "../Pages/HR_Staff/staffProfile";
import DocumentLetters from "../Pages/HR_Staff/documentLetters";
import Lead from "../Pages/Lead";
import Organization from "../Pages/Organization/Organization";
import Position from "../Pages/Position/Position";
import AddRole from "../Pages/role/addRole";
import Role from "../Pages/role/index";
import SalesDashboard from "../Pages/SalesDashboard";
import Aliased from "../Pages/Aliased";
import Technology from "../Pages/Technology";
import Deal from "../Pages/Deal";
import Interview from "../Pages/Interview";
import StaffOrganizationConfig from "../Pages/HR_Staff/StaffOrganizationConfig";
import Inquiry from "../Pages/Inquiry";
import OvertimePolicy from "../Pages/Hr/Setting/OvertimePolicy/OvertimePolicy";
import OvertimeRequests from "../Pages/Hr/OvertimeRequests";
import Onboarding from "../Pages/Onboarding/Onboarding"; // eslint-disable-line no-unused-vars
import PayrollTemplates from "../Pages/Hr/Payroll/PayrollTemplates";
import TemplateBuilder from "../Pages/Hr/Payroll/PayrollTemplates/TemplateBuilder";
// import PayrollRun from "../Pages/Hr/Payroll/PayrollRun";
import BatchDetail from "../Pages/Hr/Payroll/PayrollHistory/BatchDetail";
import PayrollHistory from "../Pages/Hr/Payroll/PayrollHistory";
import PayrollReports from "../Pages/Hr/Payroll/PayrollReports";
import PtSlabConfig from "../Pages/Hr/Payroll/PayrollSettings/PtSlabConfig";
import TdsSlabConfig from "../Pages/Hr/Payroll/PayrollSettings/TdsSlabConfig";
import SupportCenter from "../Pages/Support";

const StaffAttendance = lazy(() => import("../Pages/Hr/StaffAttendance"));

export const routes = [
  {
    path: `/center`,
    Component: <CenterPage />,
    module_name: moduleName.Center,
  },
  {
    path: `/position`,
    Component: <Position />,
    module_name: moduleName.Position,
  },
  {
    path: `/organization`,
    Component: <Organization />,
    module_name: moduleName.Organization,
  },
  {
    path: `/staff-attendance`,
    Component: (
      <Suspense fallback={<div>Loading...</div>}>
        <StaffAttendance />
      </Suspense>
    ),
    module_name: moduleName.StaffAttendance,
  },
  {
    path: `/salaryOverview/:staffId`,
    Component: <HrLayout component={<SalaryOverview />} />,
    module_name: moduleName.Salary,
    parent_path: `/staff`,
  },
  {
    path: `/salaryStructure/:staffId`,
    Component: <HrLayout component={<SalaryStructure />} />,
    module_name: moduleName.Salary,
    parent_path: `/staff`,
  },
  {
    path: `/reviseSalaryStructure/:staffId`,
    Component: <HrLayout component={<ReviseSalary />} />,
    module_name: moduleName.Salary,
    parent_path: `/staff`,
  },
  {
    path: `/editSalaryStructure/:staffId`,
    Component: <HrLayout component={<EditSalary />} />,
    module_name: moduleName.Salary,
    parent_path: `/staff`,
  },
  {
    path: `/salaryHistory/:staffId`,
    Component: <HrLayout component={<SalaryHistory />} />,
    module_name: moduleName.Salary,
    parent_path: `/staff`,
  },
  {
    path: `/setting`,
    Component: <Setting />,
    module_name: moduleName.Setting,
  },
  {
    path: `/letterTemplates`,
    Component: <LetterTemplates />,
    module_name: moduleName.Setting,
    parent_path: `/setting`,
  },
  {
    path: `/profile`,
    Component: <HrLayout component={<StaffProfile />} />,
    module_name: moduleName.Public,
  },
  {
    path: `/staffProfile`,
    Component: <StaffProfile />,
    module_name: moduleName.Staff,
    parent_path: `/staff`,
  },
  {
    path: `/staffOrganizationConfig`,
    Component: <StaffOrganizationConfig />,
    module_name: moduleName.Public,
  },
  {
    path: `/staffProfile/:staffId`,
    Component: <HrLayout component={<StaffProfile />} />,
    module_name: [moduleName.Staff, moduleName.Public],
    parent_path: `/staff`,
  },
  {
    path: `/documentLetters/:staffId`,
    Component: <HrLayout component={<DocumentLetters />} />,
    module_name: [moduleName.Staff, moduleName.Public],
    parent_path: `/staff`,
  },
  {
    path: `/HrDashboard`,
    Component: <HrDashboard />,
    module_name: moduleName.Dashboard,
  },
  {
    path: `/LateEntry`,
    Component: <LateEntry />,
    module_name: moduleName.LateEntry,
  },
  {
    path: `/hr_edit_late_entry`,
    Component: <EditLateEntry />,
    module_name: moduleName.LateEntry,
    parent_path: `/setting`,
  },
  {
    path: `/holidayTemplate`,
    Component: <HolidayTemplate />,
    module_name: moduleName.Holiday,
    parent_path: `/setting`,
  },
  {
    path: `/createHolidayTemplate`,
    Component: <CreateHolidayTemplate />,
    module_name: moduleName.Holiday,
    parent_path: `/setting`,
  },
  {
    path: `/editHolidayTemplate/:id`,
    Component: <CreateHolidayTemplate />,
    module_name: moduleName.Holiday,
    parent_path: `/setting`,
  },
  {
    path: `/manageStaff/:templateId`,
    Component: <ManageStaff />,
    module_name: moduleName.Holiday,
    parent_path: `/setting`,
  },
  {
    path: `/ShiftSetting`,
    Component: <ShiftSetting />,
    module_name: moduleName.Shift,
    parent_path: `/setting`,
  },
  {
    path: `/manageShiftStaff/:id`,
    Component: <ManageShiftStaff />,
    module_name: moduleName.Shift,
    parent_path: `/setting`,
  },
  {
    path: `/AddShift`,
    Component: <AddEditShift />,
    module_name: moduleName.Shift,
    parent_path: `/setting`,
  },
  {
    path: `/EditShift/:id`,
    Component: <AddEditShift />,
    module_name: moduleName.Shift,
    parent_path: `/setting`,
  },
  {
    path: `/role`,
    Component: <Role />,
    module_name: moduleName.RolePermission,
  },
  {
    path: `/addRole`,
    Component: <AddRole />,
    module_name: moduleName.RolePermission,
    parent_path: `/role`,
  },
  {
    path: `/editRole/:roleid`,
    Component: <AddRole />,
    module_name: moduleName.RolePermission,
    parent_path: `/role`,
  },
  {
    path: `/viewRole/:viewRoleId`,
    Component: <AddRole />,
    module_name: moduleName.RolePermission,
    parent_path: `/role`,
  },
  {
    path: `/SalaryDetails`,
    Component: <SalaryDetails />,
    module_name: moduleName.SalaryAccess,
    parent_path: `/setting`,
  },
  {
    path: `/leaveTemplate`,
    Component: <LeaveTemplate />,
    module_name: moduleName.Leave,
    parent_path: `/setting`,
  },
  {
    path: `/createLeaveTemplate`,
    Component: <AddEditLeaveTemplate />,
    module_name: moduleName.Leave,
    parent_path: `/setting`,
  },
  {
    path: `/editLeaveTemplate/:id`,
    Component: <AddEditLeaveTemplate />,
    module_name: moduleName.Leave,
    parent_path: `/setting`,
  },
  {
    path: `/manageLeaveStaff/:leaveId`,
    Component: <ManageLeaveStaff />,
    module_name: moduleName.Leave,
    parent_path: `/setting`,
  },
  {
    path: `/attendanceDetails/:staffId`,
    Component: <HrLayout component={<AttendanceDetails />} />,
    module_name: [moduleName.Staff, moduleName.Public],
    parent_path: `/staff`,
  },
  {
    path: `/globalConfiguration`,
    Component: <GlobalConfig />,
    module_name: [moduleName.GlobalConfiguration, moduleName.Public],
  },
  { path: `/staff`, Component: <StaffHR />, module_name: moduleName.Staff },
  {
    path: `/report`,
    Component: <Report />,
    module_name: moduleName.Report,
    parent_path: `/setting`,
  },
  {
    path: `/changePassword`,
    Component: <ChangePassword />,
    module_name: moduleName.Public,
  },
  {
    path: `/salaryOverview`,
    Component: <HrLayout component={<SalaryOverview />} />,
    module_name: moduleName.Public,
  },
  {
    path: `salaryHistory`,
    Component: <HrLayout component={<SalaryHistory />} />,
    module_name: moduleName.Public,
  },
  {
    path: `salaryStructure`,
    Component: <HrLayout component={<SalaryStructure />} />,
    module_name: moduleName.Public,
  },
  {
    path: `/attendanceApproval`,
    Component: <AttendanceApproval />,
    module_name: moduleName.AttendanceApproval,
  },
  {
    path: `/leaveApproval`,
    Component: <LeaveApproval />,
    module_name: moduleName.LeaveApproval,
  },
  {
    path: `/leaveSummary/:staffId`,
    Component: <HrLayout component={<LeaveSummary />} />,
    module_name: moduleName.Public,
    parent_path: `/staff`,
  },
  {
    path: `/leaveSummary`,
    Component: <HrLayout component={<LeaveSummary />} />,
    module_name: moduleName.Public,
    parent_path: `/staff`,
  },
  {
    path: `/leaveBalance/:staffId`,
    Component: <HrLayout component={<LeaveBalance />} />,
    module_name: moduleName.Public,
    parent_path: `/staff`,
  },
  {
    path: `/leaveBalance`,
    Component: <HrLayout component={<LeaveBalance />} />,
    module_name: moduleName.Public,
    parent_path: `/staff`,
  },
  {
    path: `/extra-working-day`,
    Component: <ExtraWorkingDay />,
    module_name: moduleName.ExtraWorkingDay,
    parent_path: `/setting`,
  },
  {
    path: `/onboarding`,
    Component: <Onboarding />,
    module_name: moduleName.Public,
  },
  {
    path: `/overtimeRequests`,
    Component: <OvertimeRequests />,
    module_name: moduleName.OvertimeRequests,
  },
  {
    path: `/overtimePolicy`,
    Component: <OvertimePolicy />,
    module_name: moduleName.OvertimePolicy,
    parent_path: `/setting`,
  },
  {
    path: `/lead`,
    Component: <Lead />,
    module_name: moduleName.Lead,
  },
  {
    path: `/Company`,
    Component: <Company />,
    module_name: moduleName.Company,
  },
  {
    path: `/Contacts`,
    Component: <Contact />,
    module_name: moduleName.Contact,
  },
  {
    path: `/SalesDashboard`,
    Component: <SalesDashboard />,
    module_name: moduleName.Dashboard,
  },
  {
    path: `/Aliased`,
    Component: <Aliased />,
    module_name: moduleName.Aliased,
  },
  {
    path: `/Technology`,
    Component: <Technology />,
    module_name: moduleName.Technology,
  },
  {
    path: `/deal`,
    Component: <Deal />,
    module_name: moduleName.Deal,
  },
  {
    path: `/interview`,
    Component: <Interview />,
    module_name: moduleName.Interview,
  },
  {
    path: `/inquiry`,
    Component: <Inquiry />,
    module_name: moduleName.Inquiry,
  },
  // Payroll — Template Management
  {
    path: `/payrollTemplates`,
    Component: <PayrollTemplates />,
    module_name: moduleName.Payroll,
    parent_path: `/setting`,
  },
  {
    path: `/payrollTemplates/new`,
    Component: <TemplateBuilder />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  {
    path: `/payrollTemplates/:id/edit`,
    Component: <TemplateBuilder />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  // Payroll — Run Wizard (commented out for future purpose)
  /*
  {
    path: `/payrollRun`,
    Component: <PayrollRun />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  */
  // Payroll — Batch Detail
  {
    path: `/payrollBatch/:id`,
    Component: <BatchDetail />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  // Payroll — History Dashboard
  {
    path: `/payrollHistory`,
    Component: <PayrollHistory />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  // Payroll — Reports
  {
    path: `/payrollReports`,
    Component: <PayrollReports />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  // Payroll — Settings
  {
    path: `/payrollSettings/ptSlabs`,
    Component: <PtSlabConfig />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  {
    path: `/payrollSettings/tdsSlabs`,
    Component: <TdsSlabConfig />,
    module_name: moduleName.Payroll,
    parent_path: `/payrollTemplates`,
  },
  // Support Center
  {
    path: `/support`,
    Component: <SupportCenter />,
    module_name: moduleName.Support,
  },
];
